module.exports = __webpack_public_path__ + "img/img5.aa47ba41.jpg";